exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".correct-answer---3NiQy{border-radius:20px;border:1px solid #bcedbd;margin-top:20px}.correct-answer---3NiQy .correct-answer-text---2MhDp{background-color:#f6fef4;text-align:center;border-radius:20px 20px 0 0;padding:10px 0}.correct-answer---3NiQy .correct-answer-container---1p-HG{padding:10px}.correct-answer---3NiQy *[data-type=\"default-content\"]{display:none}.correct-answer---3NiQy ol li [data-type=\"default-content\"]{display:block}.quest-select__menu .quest-select__option{font-family:\"Muli\",sans-serif}", ""]);

// exports
exports.locals = {
	"correct-answer": "correct-answer---3NiQy",
	"correct-answer-text": "correct-answer-text---2MhDp",
	"correct-answer-container": "correct-answer-container---1p-HG"
};